import { inject, InjectionToken } from '@angular/core';

import { createSelector, StoreConfig } from '@ngrx/store';

import {
  createSingleEntityStore,
  memoizeSelector,
  pipeState,
  SingleEntityState,
} from '@recruitee/ngrx';

import { EntityStoreKey, FEATURE_FLAGS, FeatureFlag, FeatureFlagsMap } from '../types';

const { actions, selectors, reducer, namespace } = createSingleEntityStore<FeatureFlagsMap>()(
  EntityStoreKey.featureFlags,
  {
    customActions: adapter => ({
      init: (state, payload: FeatureFlagsMap) =>
        pipeState(
          state,
          next => adapter.save(next, payload),
          next => adapter.markAsLoaded(next),
        ),
    }),
  },
);

const FeatureFlagSelectors = {
  ...selectors,
  featureEnabled: memoizeSelector((feature: FeatureFlag) =>
    createSelector(selectors.data, (featureFlagsMap: FeatureFlagsMap) => featureFlagsMap[feature]),
  ),
};

export const FeatureFlagConfigToken = new InjectionToken('FeatureFlagConfigToken', {
  providedIn: 'root',
  factory: (): StoreConfig<SingleEntityState<FeatureFlagsMap>> => ({
    initialState: {
      loaded: true,
      failed: false,
      pending: false,
      error: false,
      data: inject(FEATURE_FLAGS),
    },
  }),
});

export {
  actions as FeatureFlagEntityActions,
  reducer as FeatureFlagReducer,
  namespace as FeatureFlagNamespace,
  FeatureFlagSelectors,
};
